import { ConfiguratorIntegrations, ConfiguratorPartnership, ConfiguratorRenewalInformation } from '@models';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './configurator.actions';

export interface State {
  partnership: ConfiguratorPartnership;
}

export const featureKey = 'configurator';

export const initialState: State = {
  partnership: {},
};

export function configuratorReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.SetConfiguratorPartnership, (state, { data }) => ({ ...state, partnership: data }))
  )(state, action);
}
